import { SxProps, Theme } from '@mui/material/styles';

/**
 * Lenguaje visual compartido de "Nuestras formas de pago" para las 5 agencias
 * (UY, PY, BO, CO, Itaú PY). El contenido varía por país; el look no.
 * Referencia: MevueloUy, el primero rediseñado.
 */

const EXTERNAL_ACCENT_COLOR = '#06036c';
const DEFAULT_ACCENT_COLOR = '#31194B';

/** Header de sección con el gradiente del rediseño. */
export const paymentSectionTitleSx = (isExternal?: boolean, gradientOverride?: string): SxProps<Theme> => {
	const accentColor = isExternal ? EXTERNAL_ACCENT_COLOR : DEFAULT_ACCENT_COLOR;
	return {
		marginBottom: '10px',
		width: '100%',
		background:
			gradientOverride ??
			(isExternal ? accentColor : `linear-gradient(135deg, ${accentColor} 0%, #4a246c 58%, #ED6602 155%)`),
		paddingLeft: '18px',
		paddingRight: '18px',
		paddingTop: '10px',
		paddingBottom: '10px',
		borderRadius: '10px',
		fontSize: '1rem',
		fontWeight: 700,
		color: 'white',
		boxShadow: '0 8px 20px rgba(49, 25, 75, 0.16)',
	};
};

/** Bajada de sección con la barrita naranja a la izquierda. */
export const paymentIntroSx: SxProps<Theme> = {
	px: 1,
	pb: 1,
	borderLeft: '3px solid',
	borderColor: 'secondary.main',
	ml: 0.5,
	mb: 1,
};

/** Card contenedora blanca del bloque de pago. */
export const paymentCardSx: SxProps<Theme> = {
	padding: '14px',
	marginBottom: '16px',
	borderRadius: '10px',
	border: '1px solid rgba(49, 25, 75, 0.10)',
	boxShadow: '0 6px 18px rgba(49, 25, 75, 0.08)',
};

/** Chip pill de medio de pago (transferencia, tarjetas, etc.). */
export const paymentMethodChipSx: SxProps<Theme> = {
	borderRadius: '999px',
	fontWeight: 700,
	bgcolor: 'rgba(49, 25, 75, 0.045)',
};

/** Grilla de logos de tarjetas / medios. auto-fit también en mobile: con 3
 * tarjetas entran las 3 en una fila en vez de dejar una huérfana abajo. */
export const logoGridSx: SxProps<Theme> = {
	mt: 1.5,
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fit, minmax(96px, 1fr))',
	gap: 1,
};

/** Cajita con borde para cada logo. */
export const logoBoxSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: 1,
	borderRadius: '8px',
	border: '1px solid rgba(49, 25, 75, 0.08)',
	backgroundColor: 'rgba(49, 25, 75, 0.025)',
	'& img': {
		maxWidth: '100%',
		height: 'auto',
	},
};

/** Fila de beneficio bancario (promos PY, Itaú, Multi Red BO). */
export const benefitRowSx: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 1,
	backgroundColor: '#fff',
	borderRadius: '10px',
	border: '1px solid rgba(49, 25, 75, 0.10)',
	boxShadow: '0 4px 12px rgba(49, 25, 75, 0.06)',
	padding: '10px 12px',
	marginTop: '8px',
	position: 'relative',
};

/** Nota final ("Consultá con tu banco…"). */
export const paymentNoteSx: SxProps<Theme> = {
	marginTop: '14px',
};
